import { AccountState, CandidateState, ElectionState, ElectionStatus, PartyState } from './_generatedTypes.g';

export const getCandidateById = (state: CandidateState[], candidateId: number) => state.filter(c => c.CandidateId === candidateId)[0];
export const getPartyById = (state: PartyState[], partyId: number) => state.filter(p => p.PartyId === partyId)[0];
export const getElectionById = (state: ElectionState[], electionId: number) => state.filter(e => e.ElectionId === electionId)[0];
export const getPartiesForElection = (state: PartyState[], electionId: number) => state.filter(party => party.ElectionId === electionId);
export const isAnyCandidateElectionInCandidacyStatus = (elections: ElectionState[]) => elections.some(e => e.CandidateSystem && e.ElectionStatus === ElectionStatus.CandidacyPeriod);

export const getElectionForPartyId = (parties: PartyState[], elections:ElectionState[], partyId: number) => {
    const party = getPartyById(parties, partyId);
    return elections.find(e => e.ElectionId === party.ElectionId)!;
}

export const canEditPartyStructure = (account: AccountState, parties: PartyState[], elections:ElectionState[], partyId: number) => {
    const party = getPartyById(parties, partyId);
    const election = getElectionForPartyId(parties, elections, partyId);
    return (election.ElectionStatus === ElectionStatus.NotYetOpen && account.IsAdmin)
        || (election.ElectionStatus === ElectionStatus.CandidacyPeriod) && (party.IsCurrentAccountPartyAdmin || account.IsAdmin);
}

export const canEditPartyText = (account: AccountState, parties: PartyState[], elections:ElectionState[], partyId: number) => {
    const party = getPartyById(parties, partyId);
    const election = getElectionForPartyId(parties, elections, partyId);
    return (election.ElectionStatus === ElectionStatus.NotYetOpen || election.ElectionStatus === ElectionStatus.CandidacyPeriod) && (party.IsCurrentAccountPartyAdmin || account.IsAdmin);
}

export const canEditCandidateStructure = (account: AccountState, candidates: CandidateState[], parties: PartyState[], elections:ElectionState[], candidateId: number) => {
    const candidate = getCandidateById(candidates, candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    const election = elections.find(e => e.ElectionId === candidate.ElectionId);

    return ((election!.ElectionStatus === ElectionStatus.NotYetOpen || election!.ElectionStatus === ElectionStatus.CandidacyPeriod) && account.IsAdmin)
        || ((election!.ElectionStatus === ElectionStatus.CandidacyPeriod) && election?.CandidateSystem && candidate.IsCurrentAccountCandidate)
        || (election!.ElectionStatus === ElectionStatus.CandidacyPeriod
            && (party/*workaround bug: toevoegen kandidaat kandidaatsysteem voegt geen partij toe aan state*/
                && (party.IsCurrentAccountPartyAdmin || account.IsAdmin)));
}

export const canEditCandidateText = (account: AccountState, candidates: CandidateState[], parties: PartyState[], elections:ElectionState[], candidateId: number) => {
    const candidate = getCandidateById(candidates, candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    const election = elections.find(e => e.ElectionId === candidate.ElectionId);

    return (election!.ElectionStatus === ElectionStatus.NotYetOpen || election!.ElectionStatus === ElectionStatus.CandidacyPeriod) && (party/*workaround bug: toevoegen kandidaat kandidaatsysteem voegt geen partij toe aan state*/ && party.IsCurrentAccountPartyAdmin || account.IsAdmin || candidate.IsCurrentAccountCandidate);
}

export const canAddParty = (parties: PartyState[], electionId: number) => {
    const partys = getPartiesForElection(parties, electionId);

    return !partys.find(p => p.IsCurrentAccountPartyAdmin);
}

export const canEditElection = (account: AccountState, elections:ElectionState[], electionId: number) => {
    const election = elections.find(e => e.ElectionId === electionId);
    return (election!.ElectionStatus === ElectionStatus.NotYetOpen || election!.ElectionStatus === ElectionStatus.CandidacyPeriod) && account.IsAdmin;
}

export const isCandidateAlready = (candidates: CandidateState[], electionId: number) => {
    return candidates.some(c => c.ElectionId === electionId && c.IsCurrentAccountCandidate);
}
